/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{HeatmapTileRenderer as e}from"./tileRenderers/HeatmapTileRenderer.js";import{SymbolTileRenderer as r}from"./tileRenderers/SymbolTileRenderer.js";function t(t,n){if(!t)return null;switch(t.type){case"symbol":return new r(n);case"heatmap":return new e(n)}}export{t as createOrReuseTileRenderer};
